/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const GET_SITE_LIST_RESPONSE = {
	name: "Cisco",
	sites: [
		{
			siteId: "19",
			siteName: "BOS13",
			lat: 41.6688,
			lng: -70.2962,
			city: "Boston",
			phase: 3
		},
		{
			siteId: "13",
			siteName: "ED.CampusDC1",
			lat: 55.952,
			lng: -3.115,
			city: "East Lothian",
			phase: 3
		}
	]
};

export const GET_METRIC_OVERVIEW_RESPONSE = {
	sites: [
		{
			siteId: "13",
			year: 2025,
			aggregatedMetrics: {
				cer: { aa: 3.6, yt: 3.6, ytd: 3.6 },
				pue: { aa: 1.29, yt: 1.29, ytd: 1.29 },
				totalCo2Emissions: { aa: 328792.4, yt: 3945508.88, ytd: 3945508.88 }
			},
			lastUpdatedMonth: 12
		}
	]
};

export const GET_METRIC_DATA_RESPONSE = [
	{
		siteId: "19",
		metricId: 18,
		unitType: "kgCO₂e",
		widgetType: "key_metric",
		metrics: {
			Unit: "kgCO₂e",
			data: [
				{ label: "2025-01-01 00:00:00.000", value: 731.6 },
				{ label: "2025-02-01 00:00:00.000", value: 745.8 }
			],
			Total: "8669.10",
			annualAvg: "722.43",
			metricName: "Scope 2 - Location Based Emissions (LBE)"
		}
	},
	{
		siteId: "19",
		metricId: 6,
		unitType: "kWh",
		widgetType: "bar_chart",
		metrics: {
			Unit: "kWh",
			data: [
				{ label: "2025-01-01 00:00:00.000", value: 856815 },
				{ label: "2025-02-01 00:00:00.000", value: 960847 }
			],
			Total: "9990536.00",
			annualAvg: "832544.67",
			metricName: "Electricity Used by Cooling Systems (ECooling)"
		}
	}
];
